import * as React from 'react'
import styled from 'styled-components'

import Common, { TwoRows } from './Common'
import { styledComponentWithProps } from '../../Styled/Shared'

const BrochureImg = require('./brochures.jpg')
const FeatureImg = require('./featureImg.jpg')

const HeroBg = require('./grph_element_5.svg')

const HeroBlock = styled.div`
  flex: 1 0 0%;
  background: url(${HeroBg}) left / 300px no-repeat #8a999f;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 330px;
  margin-bottom: 10px;
  h2 {
    color: ${({ theme }) => theme.colors.invert};
    font-size: 25px;
    font-weight: bold;
    margin-left: 10px;
  }

  img {
    width: 350px;
    max-width: 100%;
  }
`

const Column = styled.div`
  flex: 1 0 0%;
  margin-right: 10px;

  img {
    max-width: 100%;
  }
`

const ImgArrow = require('./arrow.svg')
const ImgPdf = require('./pdf.svg')

const FeatureBoxWrapper = styledComponentWithProps<
  { pdf?: boolean },
  HTMLAnchorElement
>(styled.a)`
  display: flex;
  flex-direction: row;
  height: 70px;
  background: ${({ theme }) => theme.colors.invert};
  color: ${({ theme }) => theme.colors.default};
  text-decoration: none;
  width: 49%;
  margin-bottom: 10px;
  align-items: center;

  .left {
    align-self: stretch;
    text-align: center;

    width: 56px;
    flex: 0 0 56px;
    color: ${({ theme }) => theme.colors.invert};
    background: ${({ pdf }) =>
      pdf
        ? `url(${ImgPdf}) #AFD049 center center / 40px 40px no-repeat`
        : `url(${ImgArrow}) #0073c9 center center / 40px 40px no-repeat`};
  }

  .right {
    padding: 5px 10px;
  }

  h4 {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.3px;
  }
`

const FeatureGrid = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`

const FeatureBox = ({
  title,
  pdf,
  href
}: {
  title: string
  pdf?: boolean
  href: string
}) => (
  <FeatureBoxWrapper pdf={pdf} href={href} target="_blank">
    <div className="left" />
    <div className="right">
      <h4>{title}</h4>
    </div>
  </FeatureBoxWrapper>
)

const productLinks = require('./products.json')

const Products = () => (
  <Common>
    <h2 className="feature-title">DELTABEAM&reg; Product info</h2>
    <TwoRows>
      <Column>
        <FeatureGrid>
          {productLinks.links.map(link => (
            <FeatureBox key={link.text} title={link.text} href={link.url} />
          ))}
        </FeatureGrid>
        <img src={FeatureImg} alt="" />
      </Column>
      <Column>
        <HeroBlock>
          <h2>
            Brochures and<br />manuals{' '}
          </h2>
          <img src={BrochureImg} alt="" />
        </HeroBlock>
        <FeatureGrid>
          {productLinks.pdfs.map(pdf => (
            <FeatureBox
              key={pdf.text}
              pdf={true}
              href={pdf.url}
              title={pdf.text}
            />
          ))}
        </FeatureGrid>
      </Column>
    </TwoRows>
  </Common>
)

export default Products



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/Product.tsx